<template>
  <div class="container">
    <div class="title">数据统计</div>
    <div class="content">如何正确统计分析数据？——这里有简单好用的统计分析工具、高效实用的统计分析方法</div>
    <div class="main">
      <div class="main-left">
        <div class="main-right-top">
          <div class="main-right-top-child"
               :class="{ active: activeIndex == 0 }"
               @click="activeIndex = 0">软件与工具</div>
          <div class="main-right-top-child"
               style="margin-left: 5px;"
               :class="{ active: activeIndex == 1 }"
               @click="activeIndex = 1">推荐课程</div>
          <div class="more"
               @click="toMore"
               v-show="activeIndex == 0 && toolList.length > 0">查看更多 ></div>
          <div class="more"
               @click="toMore"
               v-show="activeIndex == 1 && videoList.length > 0">查看更多 ></div>
        </div>
        <div class="main-right-bottom"
             v-if="activeIndex == 0 && toolList.length > 0">
          <swiper :options="option">
            <swiper-slide v-for="(item, index) in toolList"
                          :key="index">
              <img :src="item.slideShow"
                   alt=""
                   class="left-img"
                   @click="itemClick(item)">
              <div class="name"
                   @click="itemClick(item)">{{ item.title }}</div>
              <div class="introduce"
                   @click="itemClick(item)">{{ item.abstract }}</div>
            </swiper-slide>
          </swiper>
          <div class="t5prevbutton el-icon-arrow-left"></div>
          <div class="t5nextbutton el-icon-arrow-right"></div>
        </div>
        <div class="wu"
             v-if="activeIndex == 0 && toolList.length <= 0">
          <img src="../../assets/image/wu.png"
               alt=""
               style="margin-top: 30px">
        </div>
        <div class="main-right-video"
             v-if="activeIndex == 1">
          <div class="video-child"
               v-for="(key, k) in videoList"
               :key="k"
               @click="toVideo(key)">
            <img :src="key.acr_PictResUrl"
                 class="video-img"></img>
            <div class="main-left-child-content">{{ key.title }}</div>
            <img src="../../assets/icon/video.png"
                 class="bf"
                 alt="">
          </div>
        </div>
        <div class="wu"
             v-if="activeIndex == 1 && videoList.length <= 0">
          <img src="../../assets/image/wu.png"
               alt=""
               style="margin-top: 30px">
        </div>
      </div>
      <div class="main-right">
        <div class="main-left-child"
             @click="toInforList">
          <div class="main-left-child-title"
               v-if="navList.length > 0">统计分析方法</div>
          <img class="img"
               src="../../assets/img/sj1.png"
               alt="">
          <div class="main-left-child-content">选对统计方法，深度分析数据</div>
          <div class="main-left-child-detail">查看详情 ></div>
        </div>
        <div class="main-left-child"
             @click="toInforList"
             style="margin-left: 40px;">
          <div class="main-left-child-title"
               v-if="navList.length > 0">统计结果解读</div>
          <img class="img"
               src="../../assets/img/sj2.png"
               alt="">
          <div class="main-left-child-content">统计结果的科学解释与表达</div>
          <div class="main-left-child-detail">查看详情 ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  // props: {
  //   videoList: {
  //     type: Array,
  //     default: []
  //   }
  // },
  data () {
    return {
      activeIndex: 0,
      option: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 0,
        navigation: {
          nextEl: '.t5nextbutton',
          prevEl: '.t5prevbutton',
          disabledClass: 't5-button-disabled'
        }
      },

      subjectList: [],
      designList: [],
      toolList: [],

      navList: [],

      videoList: []
    }
  },

  created () {
    this.getColumn()
    this.getVideoList()
  },

  methods: {
    // 获取栏目
    getColumn () {
      let params = {
        c_Id: this.httphelper.baseApi() == 'https://apitest.gp519.com/api/' ? 217 : 250,
        isCHorEN: 1
      }
      this.httphelper.post('/ScientificApi/GetColumsInfoAllList', params).then(res => {
        console.log(res, '数据统计')
        if (res.code == 200) {
          let data = res.data
          data.forEach(item => {
            if (item.infoType == 1) {
              this.navList.push(item)
            } else {
              let params = {
                keyword: '',
                c_Id: item.id,
                c_PId: 0,
                userId: 0,
                pageIndex: 1,
                pageSize: 10
              }
              this.httphelper.post('/ScientificApi/GetSRNewInfoPageList', params).then(res => {
                this.toolList = res.data
              })
            }

          });
        }
      })
    },

    toMore () {
      if (this.activeIndex == 0) {
        this.$router.push('/tool#top4')
      } else {
        this.$router.push({
          path: '/course#top4',
          // query: {
          //   id: 4
          // }
        })
      }
    },

    getVideoList () {
      let params = {
        labelName: '数据统计',
        number: 2
      }
      this.httphelper.post('NewApi/GetDbRecommendHomeCoursePageList', params).then(res => {
        this.videoList = res.data
      })
    },

    toInforList () {
      const { href } = this.$router.resolve({
        path: '/Inforlist',
        query: {
          id: this.httphelper.baseApi() == 'https://apitest.gp519.com/api/' ? 217 : 250,
          labelName: '数据统计',
        }
      });
      window.open(href, '_blank')
    },

    itemClick (item) {
      if (item.address) {
        window.open(item.address, '_blank')
      } else {
        const { href } = this.$router.resolve({
          path: '/inforDetails',
          query: {
            id: item.id,
            column_Type: 0
          }
        });
        window.open(href, '_blank')
      }
    },

    toVideo (item) {
      let url = this.httphelper.IsVideo() + '/detail?courseId=' + item.id;
      window.open(url);
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  width: 100%;
  height: 100vh;
  background: url("../../assets/image/banner5.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  padding-top: 220px;
  .title {
    width: 100%;
    text-align: center;
    font-size: 32px;
    font-family: Microsoft YaHei;
    font-weight: bold;
    color: #000000;
  }
  .content {
    width: 100%;
    text-align: center;
    font-size: 14px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #000000;
    margin-top: 18px;
  }
  .main {
    width: 80%;
    // height: 450px;
    margin: 50px auto;
    display: flex;
    .main-left {
      position: relative;
      padding-right: 60px;
      width: 50%;
      padding-top: 42px;
      padding-bottom: 42px;
      .main-right-top {
        width: 100%;
        display: flex;
        align-items: flex-end;
        .main-right-top-child {
          width: 120px;
          height: 36px;
          background: #fff;
          border: 1px solid #d5d5d5;
          border-radius: 18px;
          text-align: center;
          line-height: 36px;
          cursor: pointer;
        }
        .active {
          color: #0b8586;
          background: #edfafa;
          border: 1px solid #0b8586;
        }
      }
      .main-right-bottom {
        width: 100%;
        position: relative;
        cursor: pointer;
        .left-img {
          width: 300px;
          height: 172px;
          background: #fff;
          margin: 26px auto;
          border-radius: 8px;
          display: block;
          border: 1px solid #e5e5e5;
          box-shadow: 7px 19px 30px 0px rgba(0, 0, 0, 0.06);
        }
        .left-img:hover {
          border: 1px solid #0b8586;
          box-shadow: 7px 19px 30px 0px rgba(11, 133, 134, 0.35);
        }
        .name {
          font-size: 18px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          text-align: center;
          margin: 22px auto 0 auto;
        }
        .introduce {
          width: calc(100% - 40px);
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          line-height: 25px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          margin: 0 auto;
        }
        .el-icon-arrow-left,
        .el-icon-arrow-right {
          font-size: 30px;
          color: #0b8586;
          cursor: pointer;
        }
        .el-icon-arrow-left {
          position: absolute;
          top: 30%;
          transform: translateY(30%);
          left: -35px;
          z-index: 9;
        }
        .el-icon-arrow-right {
          position: absolute;
          top: 30%;
          transform: translateY(30%);
          right: -35px;
          z-index: 9;
        }
        .t5-button-disabled {
          color: #d5d5d5;
        }
      }

      .main-left-child:hover {
        .img {
          border: 1px solid #0b8586;
          box-shadow: 7px 19px 30px 0px rgba(11, 133, 134, 0.35);
        }
        .main-left-child-detail {
          color: #0b8586;
        }
      }

      .main-right-video {
        display: flex;
        justify-content: center;
        .video-child {
          width: 300px;
          position: relative;
          cursor: pointer;
          .video-img {
            // width: 100%;
            width: 300px;
            height: 172px;
            background: #fff;
            margin-top: 26px;
            border-radius: 8px;
          }
          .main-left-child-content {
            margin-top: 15px;
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
            color: #000;
          }
          .bf {
            position: absolute;
            bottom: 50px;
            left: 10px;
            width: 30px;
            height: 30px;
          }
        }
        .video-child:last-child {
          margin-left: 40px;
        }
      }
    }
    .main-left::after {
      position: absolute;
      top: 0;
      right: 0;
      content: " ";
      width: 1px;
      height: 100%;
      background: rgba(0, 0, 0, 0.1);
    }

    .main-right {
      position: relative;
      width: 50%;
      display: flex;
      padding-top: 42px;
      padding-left: 60px;
      .main-left-child {
        width: 300px;
        border-radius: 8px;
        cursor: pointer;
        .main-left-child-title {
          width: 100%;
          text-align: center;
          height: 36px;
          font-size: 24px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: #000000;
          line-height: 30px;
        }
        .img {
          // width: 100%;
          width: 300px;
          height: 172px;
          background: #fff;
          margin-top: 26px;
          border-radius: 8px;
          border: 1px solid #e5e5e5;
          box-shadow: 7px 19px 30px 0px rgba(0, 0, 0, 0.06);
        }

        .main-left-child-content {
          width: 100%;
          text-align: center;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          line-height: 25px;
          margin-top: 22px;
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;
        }
        .main-left-child-detail {
          width: 100%;
          text-align: center;
          font-size: 14px;
          font-family: Microsoft YaHei;
          font-weight: 400;
          color: #000000;
          line-height: 28px;
          margin-top: 10px;
        }
      }
      .main-left-child:hover {
        .img {
          border: 1px solid #0b8586;
          box-shadow: 7px 19px 30px 0px rgba(11, 133, 134, 0.35);
        }
        .main-left-child-detail {
          color: #0b8586;
        }
      }
    }
  }
}
.more {
  // margin: 20px 0;
  // width: 50%;
  flex: 1;
  text-align: right;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #000;
  cursor: pointer;
}
.wu {
  text-align: center;
  line-height: 270px;
  font-weight: bold;
  font-size: 24px;
  // color: #fff;
}
// @media screen and (max-width: 1900px) {
//   .container {
//     padding-top: 130px;
//     .title {
//       font-size: 28px;
//       margin-top: 40px;
//     }
//     .main {
//       margin: 30px auto;
//     }
//   }
//   .container .main .main-left .main-right-bottom .left-img {
//     width: calc(100% - 10px);
//   }
// }
</style>